<template>
  <div>
    <b-row>
      <b-col>
        <h6><strong>การตั้งค่ารับรองหลักสูตรของกรมพัฒนาฝืมือแรงงาน</strong></h6>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="6">
        <b-form-group>
          <template v-slot:label>
            รหัสหลักสูตร DSD e-Learning
          </template>
          <b-input-group>
            <b-form-input
              type="text"
              v-model="form.dsdCourse.dsdcCourseCode"
              :readonly="readonly"
              :state="validDsdcCourseCode"
              @change="validDsdcCourseCode = null;"
              @blur="onblurDsdCourseCode"
              @keyup.enter="onblurDsdCourseCode"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col cols="6">
        <b-form-group>
          <DsdcLevelSelector
            label="ระดับหลักสูตร"
            attribute="dsdcLevel"
            :value="form.dsdCourse.dsdcLevel"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-form-group>
          <DsdcCareerSelector
            label="สาขาอาชีพในการฝึกอบรมฝีมือแรงงาน"
            attribute="dsdcCareerField"
            :value="form.dsdCourse.dsdcCareerField"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DsdcCareerSelector from './DsdcCareerSelector.vue';
import DsdcLevelSelector from './DsdcLevelSelector.vue';

export default {
  name: 'DsdInfoForm',
  components: {
    DsdcCareerSelector,
    DsdcLevelSelector,
  },
  props: {
    form: { type: Object, required: true },
    comId: { type: [String, Number], required: true },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      validDsdcCourseCode: null,
    };
  },
  computed: {
    ...mapGetters('CourseManagement', [
      'isLoading',
      'courseInfo',
      'courseAttributeUpdated',
    ]),
  },

  methods: {
    ...mapActions('CourseManagement', ['updateDsdcCode', 'getCourseInfo']),
    async onblurDsdCourseCode() {
      const dsdcCourseCode = this.form.dsdCourse.dsdcCourseCode;
      this.updateDsdcCode({
        courseId: this.$route.params.courseId,
        dsdcCourseCode: dsdcCourseCode,
      }).then(() => {
        this.getCourseInfo({
          courseId: this.$route.params.courseId,
          temp: true,
          excepts: 'numberOfStudent,numberOfActiveStudent',
        });
      });
    },
  },
};
</script>
